import React from 'react'

import { ErrorText } from 'components/Text'
import CircularProgress from 'material-ui/CircularProgress'

const StatusDisplay = ({ status, children }) => {

  if (!status) return null

  if (status.isError) {
    return <ErrorText>{children}</ErrorText>
  }
  else if (status.isLoading) {
    return <CircularProgress size={40} />
  }

  return null
}

export default StatusDisplay



// WEBPACK FOOTER //
// ./src/components/StatusDisplay/index.js